export const clippathList = [
  {
    label: 'None',
    value: ''
  },
  {
    label: 'Clip Top Slide',
    value: 'clip-top-slide',
  },
  {
    label: 'Clip Bottom Slide',
    value: 'clip-bottom-slide',
  },
  {
    label: 'Clip Top Bottom Slide',
    value: 'clip-top-bottom-slide',
  },
  {
    label: 'Clip Parallel Right',
    value: 'clip-parallel-right',
  },
  {
    label: 'Clip Parallel Left',
    value: 'clip-parallel-left',
  },  
  {
    label: 'Clip Arrow Right',
    value: 'clip-arrow-right',
  },
  {
    label: 'Clip Arrow Left',
    value: 'clip-arrow-left',
  },
  {
    label: 'Clip Message',
    value: 'clip-message',
  },
  {
    label: 'Clip Parallel',
    value: 'clip-parallel',
  },
  {
    label: 'Clip Right Chevron',
    value: 'clip-right-chevron',
  },
  {
    label: 'Clip Left Chevron',
    value: 'clip-left-chevron',
  },
  {
    label: 'Clip Random Blob',
    value: 'clip-random-blob',
  },
  {
    label: 'Clip Random Oval',
    value: 'clip-random-oval',
  },
  {
    label: 'Clip Bottom Wave',
    value: 'clip-bottom-wave',
  },
  {
    label: 'Clip Ellipse',
    value: 'clip-ellipse',
  },
  {
    label: 'Clip Ellipse Top',
    value: 'clip-ellipse-top',
  },
  {
    label: 'Clip Camera',
    value: 'clip-camera',
  },
  
  {
    label: 'Custom',
    value: 'custom',
  }  
]
